import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainservicelistComponent } from './mainservices/mainservicelist/mainservicelist.component';
import { MainserviceformComponent } from './mainservices/mainserviceform/mainserviceform.component';
import { SubservicelistComponent } from './subservices/subservicelist/subservicelist.component';
import { SubserviceformComponent } from './subservices/subserviceform/subserviceform.component';
import { SubservicesfieldsformComponent } from './subservicesfields/subservicesfieldsform/subservicesfieldsform.component';
import { SubservicesfieldsdropdownitemsformComponent } from './subservicesfieldsdropdownitems/subservicesfieldsdropdownitemsform/subservicesfieldsdropdownitemsform.component';
import { ServicesamountsfeesformComponent } from './servicesamountsfees/servicesamountsfeesform/servicesamountsfeesform.component';
import { ServiceordersComponent } from './servicesorders/serviceorders/serviceorders.component';
import { ServicesbymandoobComponent } from './reports/servicesbymandoob/servicesbymandoob.component';

const routes: Routes = [

  { path: 'mainservicelist', component: MainservicelistComponent },
  { path: 'mainserviceform', component: MainserviceformComponent },
  { path: 'mainserviceform/:id', component: MainserviceformComponent },

  { path: 'subservicelist', component: SubservicelistComponent },
  { path: 'subserviceform', component: SubserviceformComponent },
  { path: 'subserviceform/:id', component: SubserviceformComponent },

  { path: 'subservicefields', component: SubservicesfieldsformComponent },
  { path: 'subservicefieldsdropdownitems', component: SubservicesfieldsdropdownitemsformComponent },

  { path: 'serviceamountsfees', component: ServicesamountsfeesformComponent },

  { path: 'serviceorders', component: ServiceordersComponent },
  { path: 'serviceordersbymandoobreport', component: ServicesbymandoobComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ServicesRoutingModule { }
